<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Usuários Ponto Apoio | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="nome">Nome: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.nome }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.status_desc }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="cpf">CPF: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.cpf }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="telefone">Telefone: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.telefone }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="email">E-mail: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.email }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="perfil">Perfil: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.perfil.nome }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="perfil">Ponto de Apoio: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.ponto_apoio_usuario.cd_ponto_apoio }}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCpf } from '@brazilian-utils/formatters'
import Formatters from '../../helpers/Formatters'
import UsuarioActions from '../../actions/UsuarioActions'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      registro: {
        nome: '',
        cpf: '',
        telefone: '',
        email: '',
        senha: '',
        cd_perfil: '',
        cd_sistema: '',
        idc_status: '',
        status_desc: '',
        perfil: {
          nome: ''
        },
        ponto_apoio_usuario: {
          cd_ponto_apoio: ''
        }
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    UsuarioActions.obterUsuario(this.id)
      .then(res => {
        if (res && res.nome) {
          this.registro = res

          this.registro.cpf = formatCpf(this.registro.cpf)
          this.registro.telefone = Formatters.formataNumeroTelefone(this.registro.telefone)

          this.registro.perfil = this.registro.perfil === null ? { nome: null } : this.registro.perfil
          this.registro.ponto_apoio_usuario = this.registro.ponto_apoio_usuario === null ? { cd_ponto_apoio: null } : this.registro.ponto_apoio_usuario
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/usuarios-ponto-apoio')
    },
    editar () {
      this.$router.push('/usuarios-ponto-apoio/' + this.id + '/e')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/usuarios-ponto-apoio/Detalhes.vue